var React = require('react');
var ReactNative = require('react-native');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager');
var ArcMeter = require('./ArcMeter');
var ModelConstants = require('./constants/ModelConstants');

// const Icon = require('./wrappers/ReUpIcon');

var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpText = require('./ReUpText');
var ReUpButton = require('./ReUpButton');
var ImageMeter = require('./ImageMeter');
var PointsTicker = require('./PointsTicker');
var AddToWalletButton = require('./AddToWalletButton');

var ModelConstants = require('./constants/ModelConstants');

const Icon = require('./wrappers/ReUpIcon');

var {
  View,
  Animated,
  ScrollView,
  StyleSheet,
  Platform,
  Image,
} = ReactNative;

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton,
  MKSpinner
} = MK;

var FeedPlusView = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      showOnlyTappable: false,
      upArrowSelected: ()=>{},
      initialLayout:{width:-1, height:-1}
    }
  },

  getInitialState : function()
  {
    var feedPlusFeatures = this.props.appManager.getFeedPlusFeatures();
    var shouldHideArrow = true;
    for( var i = 0; i < feedPlusFeatures.length; i++ )
    {
      if( feedPlusFeatures[i].key != "Login" && feedPlusFeatures[i].key != "CreateUser" )
      {
        shouldHideArrow = false;
        break;
      }
    }
    return {
      zoomOut: 0,
      points: 0,
      rewards: null,
      isVisible:true,
      enabled:true,
      shouldHideArrow:shouldHideArrow
    }
  },

  _context : 500,
  componentDidMount : function()
  {
    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);
    if( this.props.appManager.isLoggedIn() )
    {
      this.setState({points: this.props.appManager.currentUser().Points});
    }
    this.props.appManager.getDataType("Rewards", (rewards)=>
    {
      if( typeof rewards !== 'undefined' && rewards != null )
      {
        this.setRewards(rewards)
      }
    })
  },

  componentWillUnmount : function()
  {
    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
  },

  checkUserChanged : function()
  {
    var loggedIn = this.props.appManager.isLoggedIn();
    if( loggedIn )
    {
      var user = this.props.appManager.currentUser();
      this.setState({points:user.Points});
    }
  },

  setEnabled : function(enabled)
  {
    if( enabled != this.state.enabled ) this.setState({enabled});
  },

  setZoomOut : function(zoomOut)
  {
    zoomOut = Math.min(1,zoomOut);
    this.setState({zoomOut})
  },

  setVisible: function(isVisible)
  {
    if( this.state.isVisible != isVisible ) this.setState({isVisible})
  },

  setRewards: function(rewards)
  {
    // TODO:remove
    var appManager = this.props.appManager;
    if( appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com" )
    {
      this.setState({rewards:{RewardID:0, RewardName:"Reward", Description:"A reward here", Points:100}});
    }
    else
    {
      this.setState({rewards: rewards.sort((a,b)=>
      {
        if( a.Points == b.Points ) return b.RewardName.localeCompare(a.RewardName);
        else return a.Points - b.Points;
      })})
    }
  },

  getLocalizedRewardData: function(reward)
  {
    var preferredLocale = this.props.appManager.getActiveLocale();
    var localizedRewardData = {};
    if( typeof reward.LocaleOverride !== 'undefined' && reward.LocaleOverride != null && reward.LocaleOverride.length > 0  )
    {
      var preferredLocaleOverrides = JSON.parse(reward.LocaleOverride);
      if( typeof preferredLocaleOverrides[preferredLocale] !== 'undefined' )
      {
        localizedRewardData.name = preferredLocaleOverrides[preferredLocale].RewardName;
        localizedRewardData.description = preferredLocaleOverrides[preferredLocale].Description;
      }
      else
      {
        localizedRewardData.name = reward.RewardName;
        localizedRewardData.description = reward.Description;
      }
    }
    else
    {
        localizedRewardData.name = reward.RewardName;
        localizedRewardData.description = reward.Description;
    }
    
    return localizedRewardData;
  },

  setPoints: function(points)
  {
    if( points != this.state.points ) this.setState({points})
  },

  renderRewardMeter: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    var generalColor = !appManager.shouldInvertColorOnFeedPlus() ? appManager.getColorForKey("GeneralColor") : appManager.getColorForKey("GeneralTitleColor");
    var generalTitleColor = appManager.shouldInvertColorOnFeedPlus() ? appManager.getColorForKey("GeneralColor") : appManager.getColorForKey("GeneralTitleColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
    if( profileMeterBackgroundColor == generalColor ) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor",0.4);
    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
    var circleBackgroundColor = appManager.getColorForKey("ProfileColor");
    var circleTextColor = appManager.getColorForKey("ProfileTitleColor");
    var circleIconColor = appManager.getColorForKey("ProfileImageColor");
    var cardColor = appManager.getColorForKey("FeedCardColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var rippleColor = appManager.getColorForKey("FeedCardBannerColor", 0.2);
    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var buttonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var buttonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var rewardsFetched = false;
    var meterDim = 240;
    var outerDim = 220;

    var imageMeterStyle = {flex:1, alignSelf:'stretch'};
    if( Platform.OS == 'web' )
    {
      imageMeterStyle.height = "100%";
      imageMeterStyle.width = "100%";
    }

    if( appManager.isLoggedIn() )
    {
      var amountFontSize = 60;
      var amountFontSize = 60 - ((this.state.points + "").length > 3 ? ((this.state.points + "").length - 3)*12 : 0);
      var amountLeftText1 = "";
      var amountLeftText2 = "";

      if( this.state.rewards != null && this.state.rewards.length > 0 )
      {
        var mostExpensiveAcheivedReward = null;
        var mostExpensiveAcheivedRewardLocalized = "";
        var nextReward = null;
        for( var i = 0; i < this.state.rewards.length; i++ )
        {
          var reward = this.state.rewards[i];

          if( (parseInt(reward.Points) > parseInt(this.state.points)) && ((nextReward == null) || (parseInt(nextReward.Points) > parseInt(reward.Points))) )
          {
            nextReward = reward;
          }

          if( parseInt(reward.Points) <= parseInt(this.state.points) && (mostExpensiveAcheivedReward == null || parseInt(mostExpensiveAcheivedReward.Points) < parseInt(reward.Points)))
          {
            mostExpensiveAcheivedReward = reward;
            mostExpensiveAcheivedRewardLocalized = this.getLocalizedRewardData(mostExpensiveAcheivedReward);
          }
        }

        if( nextReward != null )
        {
          var localizedPoints = locManager.localizedPoints(nextReward.Points - this.state.points);
          var localizedRewardData =  this.getLocalizedRewardData(nextReward);
          amountLeftText1 =  locManager.localizedStringForKeyAndParams("POINTS_LEFT_NEXT_REWARD_STATEMENT",  [localizedPoints], "%0% until next reward:");
          amountLeftText2 = localizedRewardData.name;
        }
        rewardsFetched = true;
      }

      var myCardFeatureData = appManager.getFeatureForName("MyCard");
      var rewardsCampaignsFeatureData = appManager.getFeatureForName("RewardsCampaigns");
      var createUserFeatureData = appManager.getFeatureForName("CreateUser");
      var auphanFeatureData = appManager.getFeatureForName("Auphan");
      var grabbFeatureData = appManager.getFeatureForName("Grabb");
      var earnPayFeatureData = appManager.getFeatureForName("EarnPay");
      var earnPayTitle = "";
      if( typeof earnPayFeatureData !== 'undefined' )
      {
        earnPayTitle = earnPayFeatureData.data.title;
        var prereqFeature = appManager.getPrerequisiteFeatureForName("EarnPay");
        if( prereqFeature != null ) earnPayTitle = prereqFeature.data.title;
      }
      var useCreditFeatureData = appManager.getFeatureForName("UseCredit");
      var useCreditTitle = "";
      if( typeof useCreditFeatureData !== 'undefined' )
      {
        useCreditTitle = useCreditFeatureData.data.title;
        var prereqFeature = appManager.getPrerequisiteFeatureForName("UseCredit");
        if( prereqFeature != null ) useCreditTitle = prereqFeature.data.title;
      }
      // TODO:remove
      if( appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com" )
      {
        this.state.rewards = [
          {RewardID:0, RewardName:"Reward", Description:"A reward here", Points:100}
        ]
        this.state.points = 100;
      }

      switch (appManager.feedPlusType())
      {
        case 0:
        return <View pointerEvents={'box-none'} style={{flex:1}}>
          <View pointerEvents={'box-none'} style={{flex:1}} />
          <MKButton key="rewardbutton" style={[{
            flex: -1,
            borderRadius:outerDim/2,
            backgroundColor:cardColor,
            overflow:'hidden',
            padding:0
          }]}
            onPress={() =>
            {
              if( typeof rewardsCampaignsFeatureData !== 'undefined' ) this.props.appActions.requestFeatureName("RewardsCampaigns")
              else this.props.appActions.requestFeatureName("Rewards")
            }}
            underlayColor={cardColor}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            {
              this.state.rewards == null || (nextReward == null && mostExpensiveAcheivedReward == null) ?
                <View style={{flexDirection:'column', height:outerDim, width:outerDim, alignItems:'center', justifyContent:'center' }}>
                  <MKSpinner style={{
                    alignSelf : 'center',
                    backgroundColor : 'transparent',
                  }} strokeColor={[buttonColor, buttonTitleColor]} />
                </View>
              : null
            }
            {
              nextReward != null ?
                <View key="rewardmetercontainer"  style={{backgroundColor:circleBackgroundColor, paddingTop:18, borderRadius:outerDim/2, height:outerDim, width:outerDim, alignItems:'center', justifyContent:'center'}}>
                  <ArcMeter key="rewardmeter" fgColor={profileMeterColor} dimension={meterDim} thickness={14} bgColor={profileMeterBackgroundColor} percentage={(this.state.points)/nextReward.Points}>
                    <View style={{width:150, justifyContent:'center', alignItems:'center', paddingBottom:20}}>
                      <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))} style={[{fontSize:amountFontSize, color:circleIconColor, justifyContent:'center'}]}
                        renderText={(points)=>Math.round(points)}/>
                      <ReUpText appManager={appManager} style={[{color:circleTextColor, textAlign:'center'}]}>
                        {amountLeftText1}
                      </ReUpText>
                      <ReUpText appManager={appManager} isTitle={true} style={[{color:circleTextColor, textAlign:'center'}]}>
                        {amountLeftText2}
                      </ReUpText>
                    </View>
                  </ArcMeter>
                  <View style={{marginTop:18}}>
                  </View>
                </View>
              : null
            }
            {
              mostExpensiveAcheivedReward != null && nextReward == null ?
                <View key="rewardmetercontainer"  style={{backgroundColor:circleBackgroundColor, paddingTop:18, borderRadius:outerDim/2, height:outerDim, width:outerDim, alignItems:'center', justifyContent:'center'}}>
                  <ArcMeter key="rewardmeter" fgColor={profileMeterColor} dimension={meterDim} thickness={14} bgColor={profileMeterBackgroundColor} percentage={1}>
                    <View style={{width:150, justifyContent:'center', alignItems:'center', paddingBottom:20}}>
                      <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))} style={[{fontSize:amountFontSize, color:circleIconColor, justifyContent:'center'}]}
                        renderText={(points)=>Math.round(points)}/>
                      <ReUpText appManager={appManager} style={[{color:circleTextColor, textAlign:'center'}]}>
                        {locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")}
                      </ReUpText>
                      <ReUpText appManager={appManager} isTitle={true} style={[{color:circleTextColor, textAlign:'center'}]}>
                        {mostExpensiveAcheivedRewardLocalized.name}
                      </ReUpText>
                    </View>
                  </ArcMeter>
                  <View style={{marginTop:18}}>
                  </View>
                </View>
              : null
            }
          </MKButton>
          <View pointerEvents={'box-none'} style={{flex:1}} />
        </View>;

        case 1:
        var meterDim = 260;
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

        return <View pointerEvents="box-none" style={[{
          flex: 1,
          backgroundColor:'transparent',
          overflow:'hidden',
          flexDirection:'column',
          alignSelf:'stretch'
        }]}>
          <Image pointerEvents="none" key={appManager.getImageKey("feedplusHeader")} style={{alignSelf:'stretch', height:50, backgroundColor:'transparent'}} resizeMode={"contain"} source={{uri:appManager.absoluteResourceForPath('FeedPlus/header.png')}}/>
          <View style={{height:20}} />
          <MKButton key="rewardbutton" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden'
          }]}
            onPress={() =>
            {
              if( typeof rewardsCampaignsFeatureData !== 'undefined' ) this.props.appActions.requestFeatureName("RewardsCampaigns")
              else this.props.appActions.requestFeatureName("Rewards")
            }}
            underlayColor={'transparent'}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            {
              this.state.rewards == null || (nextReward == null && mostExpensiveAcheivedReward == null) ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={0}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={null}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  >
                  <View style={{flex:1,  alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                    <MKSpinner style={{
                      alignSelf : 'center',
                      backgroundColor : 'transparent',
                    }} strokeColor={[buttonColor, buttonTitleColor]} />
                  </View>
                </ImageMeter>
              : null
            }
            {
              nextReward != null ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={this.state.points/nextReward.Points}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  />
              : null
            }
            {
              mostExpensiveAcheivedReward != null && nextReward == null ?
                <ImageMeter key="rewardsmeter"
                  percentage={1}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  />
              : null
            }
          </MKButton>

          <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', marginVertical:10}}>
            <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))} style={{fontSize:20, color:generalTitleColor, textAlign:'center'}} isTitle={true}
              renderText={(points)=>locManager.localizedPoints(Math.round(points))}/>
          </View>
          {
            mostExpensiveAcheivedReward != null && nextReward == null ?
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {mostExpensiveAcheivedReward.RewardName}
                </ReUpText>
              </View>
            :
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText1}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText2}
                </ReUpText>
              </View>
          }
        </View>;
        case 2:
        meterDim = 140;
        outerDim = meterDim + 20;
        amountFontSize = amountFontSize/2;
        return <View style={{flexDirection:'column',alignItems:'center', marginBottom:20}}>
          <MKButton key="rewardbutton" style={[{
            flex: -1,
            borderRadius:outerDim/2,
            backgroundColor:'transparent',
            flexDirection:'column',
            alignItems:'center',
            marginBottom:20
          }]}
            onPress={() =>
            {
              if( typeof rewardsCampaignsFeatureData !== 'undefined' ) this.props.appActions.requestFeatureName("RewardsCampaigns", {disableUseReward:this.props.appManager.feedPlusType() == 2})
              else this.props.appActions.requestFeatureName("Rewards", {disableUseReward:this.props.appManager.feedPlusType() == 2})
            }}
            underlayColor={cardColor}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            <View style={{flex:1, alignSelf:'stretch', alignItems:'center'}}>
            {
              this.state.rewards == null || (nextReward == null && mostExpensiveAcheivedReward == null) ?
                <View style={{flexDirection:'column', height:outerDim, width:outerDim, alignItems:'center', justifyContent:'center' }}>
                  <MKSpinner style={{
                    alignSelf : 'center',
                    backgroundColor : 'transparent',
                  }} strokeColor={[buttonColor, buttonTitleColor]} />
                </View>
              : null
            }
            {
              nextReward != null ?
                <View key="rewardmetercontainer"  style={{backgroundColor:'transparent', paddingTop:18, borderRadius:outerDim/2, height:outerDim, width:outerDim, alignItems:'center', justifyContent:'center'}}>
                  <ArcMeter key="rewardmeter" fgColor={profileMeterColor} dimension={meterDim} thickness={20} bgColor={profileMeterBackgroundColor} percentage={(this.state.points)/nextReward.Points}>
                    <View style={{width:150, justifyContent:'center', alignItems:'center'}}>
                      <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))} style={[{fontSize:amountFontSize, color:generalTitleColor, justifyContent:'center'}]}
                        renderText={(points)=>Math.round(points)}/>
                      <ReUpText appManager={appManager} style={{fontSize:amountFontSize/2, textAlign:'center', color:generalTitleColor}}>
                      {this.state.points == 1 ? "pt" : "pts"}
                      </ReUpText>
                    </View>
                  </ArcMeter>
                </View>
              : null
            }
            {
              mostExpensiveAcheivedReward != null && nextReward == null ?
                <View key="rewardmetercontainer"  style={{backgroundColor:'transparent', paddingTop:18, borderRadius:outerDim/2, height:outerDim, width:outerDim, alignItems:'center', justifyContent:'center'}}>
                  <ArcMeter key="rewardmeter" fgColor={profileMeterColor} dimension={meterDim} thickness={20} bgColor={profileMeterBackgroundColor} percentage={1}>
                    <View style={{width:150, justifyContent:'center', alignItems:'center'}}>
                      <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))} style={[{fontSize:amountFontSize, color:generalTitleColor, justifyContent:'center'}]}
                        renderText={(points)=>Math.round(points)}/>
                      <ReUpText appManager={appManager} style={{fontSize:amountFontSize/2, textAlign:'center'}}>
                      {this.state.points == 1 ? "pt" : "pts"}
                      </ReUpText>
                    </View>
                  </ArcMeter>
                </View>
              : null
            }
            </View>
          </MKButton>
          <View style={{flex:-1, flexDirection:'column', alignItems:'stretch', padding:4}}>
            <ReUpText appManager={appManager} style={{textAlign:'center', color:generalTitleColor}} isTitle={true}>
            {appManager.currentUserFullName()}
            </ReUpText>
            <ReUpText appManager={appManager} style={{textAlign:'center', color:generalTitleColor}}>
            {appManager.currentUser()[ModelConstants.UserName]}
            </ReUpText>
          </View>
        </View>;

        case 3:
        var meterDim = 340;
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

        return <View pointerEvents="box-none" style={[{
          flex: 1,
          backgroundColor:'transparent',
          overflow:'hidden',
          flexDirection:'column',
          alignSelf:'stretch'
        }]}>
          <MKButton key="rewardbutton" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden'
          }]}
            onPress={() =>
            {
              if( typeof rewardsCampaignsFeatureData !== 'undefined' ) this.props.appActions.requestFeatureName("RewardsCampaigns")
              else this.props.appActions.requestFeatureName("Rewards")
            }}
            underlayColor={'transparent'}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            {
              this.state.rewards == null || (nextReward == null && mostExpensiveAcheivedReward == null) ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={0}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={null}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  overlayView={()=><View style={{width:90, flex:1, paddingTop:60}} >
                    <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))}
                      style={{fontSize:20, color:generalColor, textAlign:'center'}} isTitle={true}
                      renderText={(points)=>locManager.localizedPts(Math.round(points))}/>
                  </View>}
                  >
                  <View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                    <MKSpinner style={{
                      alignSelf : 'center',
                      backgroundColor : 'transparent',
                    }} strokeColor={[buttonColor, buttonTitleColor]} />
                  </View>
                </ImageMeter>
              : null
            }
            {
              nextReward != null ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={this.state.points/nextReward.Points}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  overlayView={()=><View style={{width:90, flex:1, paddingTop:60}} >
                    <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))}
                      style={{fontSize:20, color:generalColor, textAlign:'center'}} isTitle={true}
                      renderText={(points)=>locManager.localizedPts(Math.round(points))}/>
                  </View>}
                  />
              : null
            }
            {
              mostExpensiveAcheivedReward != null && nextReward == null ?
                <ImageMeter key="rewardsmeter"
                  percentage={1}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  overlayView={()=><View style={{width:90, flex:1, paddingTop:60}} >
                    <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))}
                      style={{fontSize:20, color:generalColor, textAlign:'center'}} isTitle={true}
                      renderText={(points)=>locManager.localizedPts(Math.round(points))}/>
                  </View>}
                  />
              : null
            }
          </MKButton>
          {
            mostExpensiveAcheivedReward != null && nextReward == null ?
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {mostExpensiveAcheivedReward.RewardName}
                </ReUpText>
              </View>
            :
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText1}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText2}
                </ReUpText>
              </View>
          }
        </View>;

        case 4:
        var meterDim = 280;
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

        return <View pointerEvents="box-none" style={[{
          flex: 1,
          backgroundColor:'transparent',
          overflow:'hidden',
          flexDirection:'column',
          alignSelf:'stretch'
        }]}>
          <View style={{height:80}}>
            <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))}
              style={{fontSize:50, color:generalTitleColor, textAlign:'center'}} isTitle={true}
              renderText={(points)=>locManager.localizedPts(Math.round(points))}/>
          </View>
          <MKButton key="rewardbutton" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden'
          }]}
            onPress={() =>
            {
              if( typeof rewardsCampaignsFeatureData !== 'undefined' ) this.props.appActions.requestFeatureName("RewardsCampaigns")
              else this.props.appActions.requestFeatureName("Rewards")
            }}
            underlayColor={'transparent'}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            {
              this.state.rewards == null || (nextReward == null && mostExpensiveAcheivedReward == null) ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={0}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={null}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  overlayView={()=>
                    <View style={{alignSelf:'stretch', flexDirection:'column', flex:1, alignItems:'center', justifyContent:'center', paddingBottom:30}}>
                      <View style={{flex:1}} />
                      {
                        mostExpensiveAcheivedReward != null && nextReward == null ?
                          <View pointerEvents="none" style={{alignSelf:'stretch', flex:1, justifyContent:'center', alignItems:'center', height:40}}>
                            <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")}
                            </ReUpText>
                            <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {mostExpensiveAcheivedRewardLocalized.name}
                            </ReUpText>
                          </View>
                        :
                          <View pointerEvents="none" style={{alignSelf:'stretch', flex:1, justifyContent:'center', alignItems:'center', height:40}}>
                            <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {amountLeftText1}
                            </ReUpText>
                            <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {amountLeftText2}
                            </ReUpText>
                          </View>
                      }
                    </View>
                  }
                  >
                  {
                    rewardsFetched == false ?
                    <View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                      <MKSpinner style={{
                        alignSelf : 'center',
                        backgroundColor : 'transparent',
                      }} strokeColor={[buttonColor, buttonTitleColor]} />
                    </View> : null
                  }
                </ImageMeter>
              : null
            }
            {
              nextReward != null ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={this.state.points/nextReward.Points}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  overlayView={()=>
                    <View style={{alignSelf:'stretch', flexDirection:'column', flex:1, alignItems:'center', justifyContent:'center'}}>
                      <View style={{flex:1}} />
                      {
                        mostExpensiveAcheivedReward != null && nextReward == null ?
                          <View pointerEvents="none" style={{alignSelf:'stretch', flex:1, justifyContent:'center', alignItems:'center'}}>
                            <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")}
                            </ReUpText>
                            <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {mostExpensiveAcheivedRewardLocalized.name}
                            </ReUpText>
                          </View>
                        :
                          <View pointerEvents="none" style={{alignSelf:'stretch', flex:1, justifyContent:'center', alignItems:'center'}}>
                            <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {amountLeftText1}
                            </ReUpText>
                            <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {amountLeftText2}
                            </ReUpText>
                          </View>
                      }
                    </View>
                  }
                  />
              : null
            }
            {
              mostExpensiveAcheivedReward != null && nextReward == null ?
                <ImageMeter key="rewardsmeter"
                  percentage={1}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  overlayView={()=>
                    <View style={{alignSelf:'stretch', flex:1, alignItems:'center', justifyContent:'center'}}>
                      <View style={{flex:1}} />
                      {
                        mostExpensiveAcheivedReward != null && nextReward == null ?
                          <View pointerEvents="none" style={{alignSelf:'stretch', flex:1, justifyContent:'center', alignItems:'center'}}>
                            <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")}
                            </ReUpText>
                            <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {mostExpensiveAcheivedRewardLocalized.name}
                            </ReUpText>
                          </View>
                        :
                          <View pointerEvents="none" style={{alignSelf:'stretch', flex:1, justifyContent:'center', alignItems:'center'}}>
                            <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {amountLeftText1}
                            </ReUpText>
                            <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                              {amountLeftText2}
                            </ReUpText>
                          </View>
                      }
                    </View>
                  }
                  />
              : null
            }
          </MKButton>
        </View>;

        case 5:
        var meterDim = 340;
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

        return <View pointerEvents="box-none" style={[{
          flex: 1,
          backgroundColor:'transparent',
          overflow:'hidden',
          flexDirection:'column',
          alignSelf:'stretch'
        }]}>
          <MKButton key="rewardbutton" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden'
          }]}
            onPress={() =>
            {
              if( typeof rewardsCampaignsFeatureData !== 'undefined' ) this.props.appActions.requestFeatureName("RewardsCampaigns")
              else this.props.appActions.requestFeatureName("Rewards")
            }}
            underlayColor={'transparent'}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            {
              this.state.rewards == null || (nextReward == null && mostExpensiveAcheivedReward == null) ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={0}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={null}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  overlayView={()=><View style={{paddingBottom:70, alignSelf:'stretch', flex:1, flexDirection:'column', justifyContent:'flex-end'}} >
                    <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))}
                      style={{fontSize:60, color:generalTitleColor, textAlign:'center'}} isTitle={true}
                      renderText={(points)=>Math.round(points)}/>
                  </View>}
                  >
                  <View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                    <MKSpinner style={{
                      alignSelf : 'center',
                      backgroundColor : 'transparent',
                    }} strokeColor={[buttonColor, buttonTitleColor]} />
                  </View>
                </ImageMeter>
              : null
            }
            {
              nextReward != null ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={this.state.points/nextReward.Points}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  overlayView={()=><View style={{paddingBottom:70, flex:1, flexDirection:'column', justifyContent:'flex-end'}} >
                    <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))}
                      style={{fontSize:60, color:generalTitleColor, textAlign:'center'}} isTitle={true}
                      renderText={(points)=>Math.round(points)}/>
                  </View>}
                  />
              : null
            }
            {
              mostExpensiveAcheivedReward != null && nextReward == null ?
                <ImageMeter key="rewardsmeter"
                  percentage={1}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  overlayView={()=><View style={{paddingBottom:70, alignSelf:'stretch', flex:1, flexDirection:'column', justifyContent:'flex-end'}} >
                    <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))}
                      style={{fontSize:60, color:generalTitleColor, textAlign:'center'}} isTitle={true}
                      renderText={(points)=>Math.round(points)}/>
                  </View>}
                  />
              : null
            }
          </MKButton>
          {
            mostExpensiveAcheivedReward != null && nextReward == null ?
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {mostExpensiveAcheivedRewardLocalized.name}
                </ReUpText>
              </View>
            :
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText1}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText2}
                </ReUpText>
              </View>
          }
        </View>;
        case 6:
        var meterDim = 320;
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

        return <View pointerEvents="box-none" style={[{
          flex: 1,
          backgroundColor:'transparent',
          overflow:'hidden',
          flexDirection:'column',
          alignSelf:'stretch'
        }]}>
          <MKButton key="rewardbutton" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden'
          }]}
            onPress={() =>
            {
              if( typeof rewardsCampaignsFeatureData !== 'undefined' ) this.props.appActions.requestFeatureName("RewardsCampaigns", {disableUseReward:this.props.appManager.feedPlusType() == 2})
              else this.props.appActions.requestFeatureName("Rewards", {disableUseReward:this.props.appManager.feedPlusType() == 2})
            }}
            underlayColor={'transparent'}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            {
              this.state.rewards == null || (nextReward == null && mostExpensiveAcheivedReward == null) ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={0}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={null}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  >
                  <View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                    <MKSpinner style={{
                      alignSelf : 'center',
                      backgroundColor : 'transparent',
                    }} strokeColor={[buttonColor, buttonTitleColor]} />
                  </View>
                </ImageMeter>
              : null
            }
            {
              nextReward != null ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={this.state.points/nextReward.Points}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  />
              : null
            }
            {
              mostExpensiveAcheivedReward != null && nextReward == null ?
                <ImageMeter key="rewardsmeter"
                  percentage={1}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  />
              : null
            }
          </MKButton>

          <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', marginVertical:10}}>
            <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))} style={{fontSize:20, color:generalTitleColor, textAlign:'center'}} isTitle={true}
              renderText={(points)=>locManager.localizedPoints(Math.round(points))}/>
          </View>
          {
            mostExpensiveAcheivedReward != null && nextReward == null ?
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {mostExpensiveAcheivedRewardLocalized.name}
                </ReUpText>
              </View>
            :
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText1}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText2}
                </ReUpText>
              </View>
          }
        </View>;
        case 7:
        var meterDim = 375;
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/600));

        return <View pointerEvents="box-none" style={[{
          flex: 1,
          backgroundColor:'transparent',
          overflow:'hidden',
          flexDirection:'column',
          alignSelf:'stretch'
        }]}>
          <View style={{flexDirection:'column', justifyContent:'flex-end', height:60}} >
            <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))}
              style={{fontSize:40, color:generalTitleColor, textAlign:'center'}} isTitle={true}
              renderText={(points)=>locManager.localizedPts(Math.round(points))}/>
          </View>
          <MKButton key="rewardbutton" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden',
            alignSelf:'stretch'
          }]}
            onPress={() =>
            {
              if( typeof rewardsCampaignsFeatureData !== 'undefined' ) this.props.appActions.requestFeatureName("RewardsCampaigns")
              else this.props.appActions.requestFeatureName("Rewards")
            }}
            underlayColor={'transparent'}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            {
              this.state.rewards == null || (nextReward == null && mostExpensiveAcheivedReward == null) ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={0}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={null}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  >
                  <View style={{flex:1,  alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                    <MKSpinner style={{
                      alignSelf : 'center',
                      backgroundColor : 'transparent',
                    }} strokeColor={[buttonColor, buttonTitleColor]} />
                  </View>
                </ImageMeter>
              : null
            }
            {
              nextReward != null ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={this.state.points/nextReward.Points}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  />
              : null
            }
            {
              mostExpensiveAcheivedReward != null && nextReward == null ?
                <ImageMeter key="rewardsmeter"
                  percentage={1}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  />
              : null
            }
          </MKButton>
          {
            mostExpensiveAcheivedReward != null && nextReward == null ?
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {mostExpensiveAcheivedRewardLocalized.name}
                </ReUpText>
              </View>
            :
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText1}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText2}
                </ReUpText>
              </View>
          }
        </View>;

        case 8:
        var meterDim = 340;
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

        return <View pointerEvents="box-none" style={[{
          flex: 1,
          backgroundColor:'transparent',
          overflow:'hidden',
          flexDirection:'column',
          alignSelf:'stretch'
        }]}>
          <MKButton key="rewardbutton" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden'
          }]}
            onPress={() =>
            {
              if( typeof rewardsCampaignsFeatureData !== 'undefined' ) this.props.appActions.requestFeatureName("RewardsCampaigns")
              else this.props.appActions.requestFeatureName("Rewards")
            }}
            underlayColor={'transparent'}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            {
              this.state.rewards == null || (nextReward == null && mostExpensiveAcheivedReward == null) ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={0}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={null}
                  fillSource={null}
                  style={imageMeterStyle}
                  overlayView={()=><View style={{paddingBottom:70, alignSelf:'stretch', flex:1, flexDirection:'column', justifyContent:'flex-end'}} >
                    <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))}
                      style={{fontSize:60, color:generalTitleColor, textAlign:'center'}} isTitle={true}
                      renderText={(points)=>Math.round(points)}/>
                  </View>}
                  >
                  <View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                    <MKSpinner style={{
                      alignSelf : 'center',
                      backgroundColor : 'transparent',
                    }} strokeColor={[buttonColor, buttonTitleColor]} />
                  </View>
                </ImageMeter>
              : null
            }
            {
              nextReward != null ?
                <ImageMeter key="rewardsmeter"
                  offsetTopPercentage={appManager.feedPlusTopOffsetPercentage()}
                  offsetBottomPercentage={appManager.feedPlusBottomOffsetPercentage()}
                  percentage={this.state.points/nextReward.Points}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  overlayView={()=><View style={{flex:1, flexDirection:'column', justifyContent:'center'}} >
                    <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))}
                      style={{fontSize:60, color:generalTitleColor, textAlign:'center'}} isTitle={true}
                      renderText={(points)=>Math.round(points)}/>
                  </View>}
                  />
              : null
            }
            {
              mostExpensiveAcheivedReward != null && nextReward == null ?
                <ImageMeter key="rewardsmeter"
                  percentage={1}
                  appManager={appManager}
                  bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                  fgSource={appManager.absoluteResourceForPath('FeedPlus/meter_fg.png')}
                  fillSource={appManager.absoluteResourceForPath('FeedPlus/meter_fill.png')}
                  style={imageMeterStyle}
                  overlayView={()=><View style={{alignSelf:'stretch', flex:1, flexDirection:'column', justifyContent:'center'}} >
                    <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))}
                      style={{fontSize:60, color:generalTitleColor, textAlign:'center'}} isTitle={true}
                      renderText={(points)=>Math.round(points)}/>
                  </View>}
                  />
              : null
            }
          </MKButton>
          {
            mostExpensiveAcheivedReward != null && nextReward == null ?
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {mostExpensiveAcheivedRewardLocalized.name}
                </ReUpText>
              </View>
            :
              <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', height:40}}>
                <ReUpText appManager={appManager} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText1}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, textAlign:'center'}]}>
                  {amountLeftText2}
                </ReUpText>
              </View>
          }
        </View>;
      }
    }
    switch (appManager.feedPlusType()) {
      case 0:
        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : circleIconColor;

        return <View pointerEvents={"box-none"} style={{flex:1, flexDirection:'column'}}>
          <View pointerEvents={"box-none"} style={{flex:1}} />
          <MKButton key="rewardbutton" style={[{
            flex: -1,
            borderRadius:outerDim/2,
            backgroundColor:cardColor,
            overflow:'hidden',
            padding:0
          }]}
            onPress={() => this.props.appActions.requestFeatureName("Login")}
            underlayColor={cardColor}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            <View key="rewardmetercontainer"  style={{backgroundColor:circleBackgroundColor, paddingTop:18, borderRadius:outerDim/2, height:outerDim, width:outerDim, alignItems:'center', justifyContent:'center'}}>
              <ArcMeter key="rewardmeter" fgColor={profileMeterColor} dimension={meterDim} thickness={14} bgColor={profileMeterBackgroundColor} percentage={0}>
                <View style={{width:150, justifyContent:'center', alignItems:'center', paddingBottom:20}}>
                  <View style={{margin:10}}>
                    <Icon name={"lock"} size={70} color={lockColor} />
                  </View>
                  <ReUpText appManager={appManager} style={[{color:circleTextColor, textAlign:'center'}]}>
                  {
                    locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
                  }
                  </ReUpText>
                </View>
              </ArcMeter>
              <View style={{marginTop:18}}>
              </View>
            </View>
          </MKButton>
          <View pointerEvents={"box-none"} style={{flex:1}} />
        </View>;

      case 1:
        var meterDim = 260;
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;

        return <View pointerEvents="box-none" style={[{
          flex: 1,
          backgroundColor:'transparent',
          overflow:'hidden',
          flexDirection:'column',
          alignSelf:'stretch'
        }]}>
          <Image pointerEvents="none" key={appManager.getImageKey("feedplusHeader")} style={{alignSelf:'stretch', height:50, backgroundColor:'transparent'}} resizeMode={"contain"} source={{uri:appManager.absoluteResourceForPath('FeedPlus/header.png')}}/>
          <View style={{height:20}} />
          <MKButton key="rewardbutton" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden'
          }]}
            onPress={() => this.props.appActions.requestFeatureName("Login")}
            underlayColor={'transparent'}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            <ImageMeter key="rewardsmeter"
              percentage={0}
              appManager={appManager}
              bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
              fgSource={null}
              fillSource={null}
              style={imageMeterStyle}
              >
              <View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                <View style={{margin:10}}>
                  <Icon name={"lock"} size={70} color={lockColor} />
                </View>
              </View>
            </ImageMeter>
          </MKButton>

          <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', marginVertical:10}}>
            <ReUpText appManager={appManager} style={{fontSize:20, color:generalTitleColor, textAlign:'center'}} isTitle={true}>
              {locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")}
            </ReUpText>
          </View>
        </View>;
        return <MKButton key="rewardbutton" style={[{
          flex: -1,
          borderRadius:outerDim/2,
          backgroundColor:cardColor,
          overflow:'hidden'
        }]}
          onPress={() => this.props.appActions.requestFeatureName("Login")}
          underlayColor={cardColor}
          rippleColor={rippleColor}
          maskBorderRadius={2}
          >
          <View key="rewardmetercontainer"  style={{backgroundColor:circleBackgroundColor, paddingTop:18, borderRadius:outerDim/2, height:outerDim, width:outerDim, alignItems:'center', justifyContent:'center'}}>
            <ArcMeter key="rewardmeter" fgColor={profileMeterColor} dimension={meterDim} thickness={14} bgColor={profileMeterBackgroundColor} percentage={0}>
              <View style={{width:150, justifyContent:'center', alignItems:'center', paddingBottom:20}}>
                <View style={{margin:10}}>
                  <Icon name={"lock"} size={70} color={circleIconColor} />
                </View>
                <ReUpText appManager={appManager} style={[{color:circleTextColor, textAlign:'center'}]}>
                {
                  locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
                }
                </ReUpText>
              </View>
            </ArcMeter>
            <View style={{marginTop:18}}>
            </View>
          </View>
        </MKButton>;
      case 3:
        var meterDim = 340;
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalColor;

        return <View pointerEvents="box-none" style={[{
          flex: 1,
          backgroundColor:'transparent',
          overflow:'hidden',
          flexDirection:'column',
          alignSelf:'stretch'
        }]}>
          <MKButton key="rewardbutton" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden'
          }]}
            onPress={() => this.props.appActions.requestFeatureName("Login")}
            underlayColor={'transparent'}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            <ImageMeter key="rewardsmeter"
              percentage={0}
              appManager={appManager}
              bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
              fgSource={null}
              fillSource={null}
              style={imageMeterStyle}
              >
              <View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                <View style={{margin:10}}>
                  <Icon name={"lock"} size={70} color={lockColor} />
                </View>
              </View>
            </ImageMeter>
          </MKButton>

          <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', marginVertical:10}}>
            <ReUpText appManager={appManager} style={{fontSize:20, color:generalTitleColor, textAlign:'center'}} isTitle={true}>
              {locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")}
            </ReUpText>
          </View>
        </View>;
      case 4:
        var meterDim = 280;
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
        if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;

        return <View pointerEvents="box-none" style={[{
          flex: 1,
          backgroundColor:'transparent',
          overflow:'hidden',
          flexDirection:'column',
          alignSelf:'stretch'
        }]}>
          <View style={{height:80}}>
          </View>
          <MKButton key="rewardbutton" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden'
          }]}
            onPress={() => this.props.appActions.requestFeatureName("Login")}
            underlayColor={'transparent'}
            rippleColor={rippleColor}
            maskBorderRadius={2}
            >
            <ImageMeter key="rewardsmeter"
              percentage={0}
              appManager={appManager}
              bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
              fgSource={null}
              fillSource={null}
              style={imageMeterStyle}
              overlayView={()=><View style={{alignSelf:'stretch', flex:1, alignItems:'center', justifyContent:'center'}}>
                <View style={{height:20}} />
                <View style={{margin:10}}>
                  <Icon name={"lock"} size={70} color={lockColor} />
                </View>
                <View style={{height:20}} />
                <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', marginVertical:10}}>
                  <ReUpText appManager={appManager} style={{color:generalTitleColor, textAlign:'center'}} isTitle={true}>
                    {locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")}
                  </ReUpText>
                </View>
              </View>}
              >
            </ImageMeter>
          </MKButton>
        </View>;

        case 5:
          var meterDim = 340;
          if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
          if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

          var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;

          return <View pointerEvents="box-none" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden',
            flexDirection:'column',
            alignSelf:'stretch'
          }]}>
            <MKButton key="rewardbutton" style={[{
              flex: 1,
              backgroundColor:'transparent',
              overflow:'hidden'
            }]}
              onPress={() => this.props.appActions.requestFeatureName("Login")}
              underlayColor={'transparent'}
              rippleColor={rippleColor}
              maskBorderRadius={2}
              >
              <ImageMeter key="rewardsmeter"
                percentage={0}
                appManager={appManager}
                bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                fgSource={null}
                fillSource={null}
                style={imageMeterStyle}
                >
                <View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                  <View style={{margin:10}}>
                    <Icon name={"lock"} size={70} color={lockColor} />
                  </View>
                </View>
              </ImageMeter>
            </MKButton>

            <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', marginVertical:10}}>
              <ReUpText appManager={appManager} style={{fontSize:20, color:generalTitleColor, textAlign:'center'}} isTitle={true}>
                {locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")}
              </ReUpText>
            </View>
          </View>;
        case 6:
          var meterDim = 320;
          if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
          if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

          var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;

          return <View pointerEvents="box-none" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden',
            flexDirection:'column',
            alignSelf:'stretch'
          }]}>
            <MKButton key="rewardbutton" style={[{
              flex: 1,
              backgroundColor:'transparent',
              overflow:'hidden'
            }]}
              onPress={() => this.props.appActions.requestFeatureName("Login")}
              underlayColor={'transparent'}
              rippleColor={rippleColor}
              maskBorderRadius={2}
              >
              <ImageMeter key="rewardsmeter"
                percentage={0}
                appManager={appManager}
                bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                fgSource={null}
                fillSource={null}
                style={imageMeterStyle}
                >
                <View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                  <View style={{margin:10}}>
                    <Icon name={"lock"} size={70} color={lockColor} />
                  </View>
                </View>
              </ImageMeter>
            </MKButton>

            <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', marginVertical:10}}>
              <ReUpText appManager={appManager} style={{fontSize:20, color:generalTitleColor, textAlign:'center'}} isTitle={true}>
                {locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")}
              </ReUpText>
            </View>
          </View>;
        case 7:
          var meterDim = 375;
          if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
          if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/600));

          var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;

          return <View pointerEvents="box-none" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden',
            flexDirection:'column',
            alignSelf:'stretch'
          }]}>
            <View style={{flexDirection:'column', justifyContent:'flex-end', height:60}} >
            </View>
            <MKButton key="rewardbutton" style={[{
              flex: 1,
              backgroundColor:'transparent',
              overflow:'hidden',
            }]}
              onPress={() => this.props.appActions.requestFeatureName("Login")}
              underlayColor={'transparent'}
              rippleColor={rippleColor}
              maskBorderRadius={2}
              >
              <ImageMeter key="rewardsmeter"
                percentage={0}
                appManager={appManager}
                bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                fgSource={null}
                fillSource={null}
                style={imageMeterStyle}
                >
                <View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                  <View style={{margin:10}}>
                    <Icon name={"lock"} size={70} color={lockColor} />
                  </View>
                </View>
              </ImageMeter>
            </MKButton>

            <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', marginVertical:10}}>
              <ReUpText appManager={appManager} style={{fontSize:20, color:generalTitleColor, textAlign:'center'}} isTitle={true}>
                {locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")}
              </ReUpText>
            </View>
          </View>;

        case 8:
          var meterDim = 340;
          if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*(meterDim/375));
          if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height*(meterDim/667));

          var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;

          return <View pointerEvents="box-none" style={[{
            flex: 1,
            backgroundColor:'transparent',
            overflow:'hidden',
            flexDirection:'column',
            alignSelf:'stretch'
          }]}>
            <MKButton key="rewardbutton" style={[{
              flex: 1,
              backgroundColor:'transparent',
              overflow:'hidden'
            }]}
              onPress={() => this.props.appActions.requestFeatureName("Login")}
              underlayColor={'transparent'}
              rippleColor={rippleColor}
              maskBorderRadius={2}
              >
              <ImageMeter key="rewardsmeter"
                percentage={0}
                appManager={appManager}
                bgSource={appManager.absoluteResourceForPath('FeedPlus/meter_bg.png')}
                fgSource={null}
                fillSource={null}
                style={imageMeterStyle}
                >
                <View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                  <View style={{margin:10}}>
                    <Icon name={"lock"} size={70} color={lockColor} />
                  </View>
                </View>
              </ImageMeter>
            </MKButton>

            <View pointerEvents="none" style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center', marginVertical:10}}>
              <ReUpText appManager={appManager} style={{fontSize:20, color:generalTitleColor, textAlign:'center'}} isTitle={true}>
                {locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")}
              </ReUpText>
            </View>
          </View>;
      default:

    }
  },

  render: function()
  {
    // return <View style={{width:100, height:100, backgroundColor:'red'}} />
    if( this.state.isVisible == false ) return null;

    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
    if( profileMeterBackgroundColor == generalColor ) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor",0.4);
    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
    var circleBackgroundColor = appManager.getColorForKey("ProfileColor");
    var circleTextColor = appManager.getColorForKey("ProfileTitleColor");
    var circleIconColor = appManager.getColorForKey("ProfileImageColor");
    var cardColor = appManager.getColorForKey("FeedCardColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var rippleColor = appManager.getColorForKey("FeedCardBannerColor", 0.2);
    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var buttonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var buttonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");

    if( appManager.isLoggedIn() )
    {
      var amountFontSize = 60;
      var amountFontSize = 60 - ((this.state.points + "").length > 3 ? ((this.state.points + "").length - 3)*12 : 0);
      var amountLeftText1 = "";
      var amountLeftText2 = "";

      if( this.state.rewards != null && this.state.rewards.length > 0 )
      {
        var mostExpensiveAcheivedReward = null
        var nextReward = null;
        for( var i = 0; i < this.state.rewards.length; i++ )
        {
          var reward = this.state.rewards[i];

          if( (parseInt(reward.Points) > parseInt(this.state.points)) && ((nextReward == null) || (parseInt(nextReward.Points) > parseInt(reward.Points))) )
          {
            nextReward = reward;
          }

          if( parseInt(reward.Points) <= parseInt(this.state.points) && (mostExpensiveAcheivedReward == null || parseInt(mostExpensiveAcheivedReward.Points) < parseInt(reward.Points)))
          {
            mostExpensiveAcheivedReward = reward;
          }
        }

        if( nextReward != null )
        {
          var localizedPoints = locManager.localizedPoints(nextReward.Points - this.state.points);
          amountLeftText1 =  locManager.localizedStringForKeyAndParams("POINTS_LEFT_NEXT_REWARD_STATEMENT",  [localizedPoints], "%0% until next reward:");
          var localizedNextRewardData = this.getLocalizedRewardData(nextReward);
          amountLeftText2 = localizedNextRewardData.name;
        }
      }

      var meterDim = 240;
      var outerDim = 220;

      var myCardFeatureData = appManager.getFeatureForName("MyCard");
      var rewardsCampaignsFeatureData = appManager.getFeatureForName("RewardsCampaigns");
      var rewardsFeatureData = appManager.getFeatureForName("Rewards");
      var settingsFeatureData = appManager.getFeatureForName("Settings");
      var simpleSettingsFeatureData = appManager.getFeatureForName("SimpleSettings");
      var createUserFeatureData = appManager.getFeatureForName("CreateUser");
      var auphanFeatureData = appManager.getFeatureForName("Auphan");
      var grabbFeatureData = appManager.getFeatureForName("Grabb");
      var orderAheadFeatureData = appManager.getFeatureForName("OrderAhead");
      var earnPayFeatureData = appManager.getFeatureForName("EarnPay");
      var earnPayTitle = "";
      if( typeof earnPayFeatureData !== 'undefined' )
      {
        earnPayTitle = earnPayFeatureData.data.title;
        var prereqFeature = appManager.getPrerequisiteFeatureForName("EarnPay");
        if( prereqFeature != null ) earnPayTitle = prereqFeature.data.title;
      }
      var useCreditFeatureData = appManager.getFeatureForName("UseCredit");
      var useCreditTitle = "";
      if( typeof useCreditFeatureData !== 'undefined' )
      {
        useCreditTitle = useCreditFeatureData.data.title;
        var prereqFeature = appManager.getPrerequisiteFeatureForName("UseCredit");
        if( prereqFeature != null ) useCreditTitle = prereqFeature.data.title;
      }
// TODO: remove
// earnPayFeatureData.data.shouldShowOnFeedPlus = false;
// useCreditFeatureData.data.shouldShowOnFeedPlus = false;
// rewardsFeatureData.data.shouldShowOnFeedPlus = true;
// if( typeof auphanFeatureData !== 'undefined' ) auphanFeatureData.data.shouldShowOnFeedPlus = true;
// if( typeof grabbFeatureData !== 'undefined' ) grabbFeatureData.data.shouldShowOnFeedPlus = true;

      var buttonWidth = 220;
      var margin = 10;
      if( appManager.shouldShowPassButton() )
      {
        buttonWidth = 142;
        margin = 4;
      }
      return(
        <View key="feedplusview" pointerEvents={this.state.enabled ? "box-none" : "none"} style={[this.props.style, {transform: [
              { scale: 1 - this.state.zoomOut},
            ], opacity:1 - this.state.zoomOut, flexDirection:'column', alignItems:'center', justifyContent:'center'}]}>
          {
            (typeof rewardsCampaignsFeatureData !== 'undefined' && rewardsCampaignsFeatureData.data.shouldShowOnFeedPlus) || (typeof rewardsFeatureData !== 'undefined' && rewardsFeatureData.data.shouldShowOnFeedPlus) ?
            this.renderRewardMeter()
            : null
          }
          {
            typeof earnPayFeatureData !== 'undefined' && earnPayFeatureData.data.shouldShowOnFeedPlus ?
              <ReUpButton appManager={appManager} style={{margin:4, width:220}} text={earnPayTitle}
                onPress={()=>{appActions.requestFeatureName("EarnPay")}} />
            : null
          }
          {
            typeof myCardFeatureData !== 'undefined' && myCardFeatureData.data.shouldShowOnFeedPlus ?
              <ReUpButton appManager={appManager} style={{margin:margin, width:buttonWidth}} text={myCardFeatureData.data.title}
                onPress={()=>
                {
                  if( typeof thisThing.props.flipSelected !== 'undefined' )
                  {
                    thisThing.props.flipSelected(myCardFeatureData)
                  }
                  else
                  {
                    appActions.requestFeatureName("MyCard");
                  }
                }} />
            : null
          }
          {appManager.shouldShowPassButton() ? <AddToWalletButton appManager={appManager} style={{margin:margin, width:buttonWidth, height:44}} /> : null}
          {
            typeof rewardsFeatureData !== 'undefined' && rewardsFeatureData.data.shouldShowOnFeedPlus ?
              <ReUpButton appManager={appManager} isSecondary={true} style={{margin:margin, width:buttonWidth}} text={rewardsFeatureData.data.shortTitle}
                onPress={()=>{appActions.requestFeatureName("Rewards", {disableUseReward:this.props.appManager.feedPlusType() == 2})}} />
            : null
          }
          {
            typeof useCreditFeatureData !== 'undefined' && useCreditFeatureData.data.shouldShowOnFeedPlus ?
              <ReUpButton appManager={appManager} style={{margin:4, width:220}} text={useCreditTitle}
                onPress={()=>{appActions.requestFeatureName("UseCredit")}} />
            : null
          }
          {
            typeof auphanFeatureData !== 'undefined' && auphanFeatureData.data.shouldShowOnFeedPlus ?
              <ReUpButton isSecondary={typeof earnPayFeatureData !== 'undefined' || typeof useCreditFeatureData !== 'undefined'} appManager={appManager} style={{margin:4, width:220}} text={auphanFeatureData.data.title}
                onPress={()=>{appActions.requestFeatureName("Auphan")}} />
            : null
          }
          {
            typeof grabbFeatureData !== 'undefined' && grabbFeatureData.data.shouldShowOnFeedPlus ?
              <ReUpButton isSecondary={typeof earnPayFeatureData !== 'undefined' || typeof useCreditFeatureData !== 'undefined'} appManager={appManager} style={{margin:4, width:220}} text={grabbFeatureData.data.title}
                onPress={()=>{appActions.requestFeatureName("Grabb")}} />
            : null
          }
          {
            typeof orderAheadFeatureData !== 'undefined' && orderAheadFeatureData.data.shouldShowOnFeedPlus ?
              <ReUpButton isSecondary={typeof earnPayFeatureData !== 'undefined' || typeof useCreditFeatureData !== 'undefined'} appManager={appManager} style={{margin:4, width:220}} text={orderAheadFeatureData.data.title}
                onPress={()=>{appActions.requestFeatureName("OrderAhead")}} />
            : null
          }
          {
            typeof simpleSettingsFeatureData !== 'undefined' && simpleSettingsFeatureData.data.shouldShowOnFeedPlus ?
              <ReUpButton isSecondary={true} appManager={appManager} style={{margin:margin, width:buttonWidth}} text={simpleSettingsFeatureData.data.title}
                onPress={()=>
                {
                  if( typeof thisThing.props.flipSelected !== 'undefined' )
                  {
                    thisThing.props.flipSelected(simpleSettingsFeatureData)
                  }
                  else
                  {
                    appActions.requestFeatureName("SimpleSettings");
                  }
                }} />
            : null
          }
          {
            !appManager.disableFeed() ?
              <View pointerEvents="box-none" style={{flexDirection:'column', alignSelf:'stretch'}}>
                <View pointerEvents="none" style={{alignSelf:'stretch', height:50}}>
                  {this.state.shouldHideArrow ? null : <ReUpIconButton ref={(c) => { this._ref_upButton = c; }} type={8} appManager={appManager} iconName={"angle-up"} onPress={()=>
                    {
                      thisThing.props.upArrowSelected();
                    }} />
                  }
                </View>
                <View pointerEvents="auto" onStartShouldSetResponder={()=>{thisThing.props.upArrowSelected();}}
                  style={{alignSelf:'stretch', height:20}} />
              </View>
            : <View style={{height:20}} />
          }
        </View>
      )
    }
    else
    {
      var amountFontSize = 60

      var meterDim = 240;
      var outerDim = 220;

      var loginFeature = appManager.getFeatureForName("Login");
      var createUserFeature = appManager.getFeatureForName("CreateUser");

      loginFeature.data.shouldShowOnFeedPlus = true;
      createUserFeature.data.shouldShowOnFeedPlus = true;
      return(
        <View key="feedplusview" pointerEvents={this.state.enabled ? "box-none" : "none"} style={[this.props.style, {transform: [
              { scale: 1 - this.state.zoomOut},
            ], opacity:1 - this.state.zoomOut, alignItems:'center', justifyContent:'center'}]}>
            {
              typeof loginFeature !== 'undefined' && loginFeature.data.shouldShowOnFeedPlus ?
                this.renderRewardMeter()
              : null
            }
            {
              typeof createUserFeature !== 'undefined' && createUserFeature.data.shouldShowOnFeedPlus ?
                <ReUpButton appManager={appManager} style={{margin:4, width:220}} text={createUserFeature.data.title}
                  onPress={()=>{appActions.requestFeatureName("CreateUser")}} />
              : null
            }
            {
              typeof loginFeature !== 'undefined' && loginFeature.data.shouldShowOnFeedPlus ?
                <ReUpButton isSecondary={true} appManager={appManager} style={{margin:4, width:220}} text={loginFeature.data.title}
                  onPress={()=>{appActions.requestFeatureName("Login")}} />
              : null
            }
            {
              !appManager.disableFeed() ?
                <View pointerEvents="box-none" style={{flexDirection:'column', alignSelf:'stretch'}}>
                  <View pointerEvents="none" style={{alignSelf:'stretch', height:50}}>
                    {this.state.shouldHideArrow ? null : <ReUpIconButton ref={(c) => { this._ref_upButton = c; }} type={8} appManager={appManager} iconName={"angle-up"} onPress={()=>
                      {
                        thisThing.props.upArrowSelected();
                      }} />
                    }
                  </View>
                  <View pointerEvents="auto" onStartShouldSetResponder={()=>{thisThing.props.upArrowSelected();}}
                    style={{alignSelf:'stretch', height:20}} />
                </View>
              : null
            }
        </View>
      )
    }
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
    backgroundColor:'red'
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
})
FeedPlusView.dataDependencies = ["Users", "Rewards"];

module.exports = FeedPlusView;
